var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 198.2",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.88,1.51L4.3,60.19c-2.68,1.74-4.3,4.71-4.3,7.9h0v120.7c0,5.2,4.21,9.41,9.41,9.41h52.67c5.2,0,9.41-4.21,9.41-9.41v-50.25c0-5.2,4.21-9.41,9.41-9.41h38.19c5.2,0,9.41,4.21,9.41,9.41v50.25c0,5.2,4.21,9.41,9.41,9.41h52.67c5.2,0,9.41-4.21,9.41-9.41v-120.7h0c0-3.19-1.62-6.17-4.3-7.9L105.12,1.51c-3.11-2.02-7.12-2.02-10.23,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDashboard);
export default __webpack_public_path__ + "static/media/menu-dashboard.e0bd208a3524d7d5e1f9d006aef41945.svg";
export { ForwardRef as ReactComponent };